// Module
var code = `<div class="row" ng-if="evaluationUrlController.url"> <div class="col-sm-12"> <generate-qr-code url="{{ evaluationUrlController.url }}" size="200"></generate-qr-code> </div> </div> <div class="row" ng-if="evaluationUrlController.url"> <div class="col-sm-12"> <h3> <code>{{ evaluationUrlController.url }}</code> </h3> </div> </div> `;
// Exports
module.exports = code;